/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */

import { TimePeriod } from '@utils/date';

export enum NotificationServices {
  MAGIC_BELL = 'magicBell'
}
export enum NotificationChannels {
  EMAIL = 'email',
  IN_APP = 'in_app',
}

export enum NotificationCategory {
  QuestionReject = 'question_reject',
  QuestionRejectPermission = 'question_reject_permission',
  QuestionDelegation = 'question_delegation',
  QuestionNoteUpdate = 'question_note_update',
  QuestionComment = 'question_comment',
  QuestionUpdate = 'question_update',
  QuestionUpdatePermission = 'question_update_permission',

  QuestionAssured = 'question_assured',
  QuestionDisputed = 'question_disputed',

  AssuranceStart = 'assurance_start',
  AssuranceQuestionUpdate = 'assurance_question_update',
  AssuranceComplete = 'assurance_complete',

  DataShareRequest = 'data_share_request',
  DataShareRevoke = 'data_share_revoke',
  DataShareReject = 'data_share_reject',
  DataShareAccept = 'data_share_accept',

  UserToUsers = 'user_to_users',
  UserToSurveyUsers = 'user_to_survey_users',
  UserToQuestionUsers = 'user_to_question_users',

  BulkSurveys = 'bulk_surveys',
  Announcements = 'announcements',
}

export enum NotificationCategoryGroup {
  SurveysAndQuestions = 'surveys_and_questions',
  DataSharing = 'data_sharing',
  Assurance = 'assurance',
  User = 'user',
}

export interface NotificationCategoryPreference {
  email: boolean,
  in_app: boolean,
  group: string,
}

export interface MagicBellPreferences {
  notification_preferences?: {
    categories: {
      [key: string]: NotificationCategoryPreference
    },
    groups: string[]
  }
}

interface NotificationSchedule {
  isSummary: boolean;
  period: TimePeriod;
}

export interface NotificationPreferences {
  userId: string;
  magicBell: MagicBellPreferences;
  notificationSchedule?: NotificationSchedule;
}

export interface NotificationPreferencesUpdateRequest {
  service: NotificationServices;
  category: string | string[];
  channel: NotificationChannels;
  setting: boolean;
}

export interface NotificationSummariesUpdateRequest {
  period: TimePeriod;
  isSummary: boolean;
}
